import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { MsalInterceptor } from '@azure/msal-angular';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { provideWgcAngularAzureCore } from '@webgate/angular-azure-core';

import { routes } from './app.routes';
import { msalBootstrapInitializer } from './initializers/msal-bootstrap.initializer';
import { AccessService } from './services/access.service';
import { ConfigService } from './services/config.service';

export const ConfigLoader = (configService: ConfigService) => {
  return () => configService.load('/assets/config/config.json');
};

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, CKEditorModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideWgcAngularAzureCore(),
    provideAppInitializer(msalBootstrapInitializer),
    provideRouter(routes),
    importProvidersFrom(BrowserModule),
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      return ConfigLoader(configService)();
    }),
    provideNoopAnimations(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'ja-JP' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    AccessService
  ]
};
